import { createRouter, createWebHashHistory } from 'vue-router';
import AppLayout from '@/layout/AppLayout.vue';
import routerKey from './routerKey';

const router = createRouter({
  scrollBehavior() {
    document.getElementById('app')?.scrollIntoView({ behavior: 'smooth' });
  },
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: AppLayout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/',
          name: routerKey.HOME,
          component: () => import('@/views/external/AdvancedSearch.vue'),
          children: [
            {
              path: '/hotel',
              name: routerKey.HOTEL,
              component: () => import('@/components/tabs/HotelTab.vue')
            },
            {
              path: '/air',
              name: routerKey.AIR,
              component: () => import('@/components/tabs/AirTab.vue')
            },
            {
              path: '/cruise',
              name: routerKey.CRUISE,
              component: () => import('@/components/tabs/CruiseTab.vue')
            },
            {
              path: '/multi-tours',
              name: routerKey.MULTI_TOURS,
              component: () => import('@/components/tabs/MultiDayToursTab.vue')
            }
          ]
        },
        {
          path: '/external/myquotes',
          name: routerKey.MY_QUOTE,
          component: () => import('@/views/external/MyQuotes.vue')
        },
        {
          path: '/external/search',
          name: routerKey.SEARCH,
          component: () => import('@/views/external/AdvancedSearch.vue'),
          children: [
            {
              path: '/external/search/hotel',
              name: routerKey.HOTEL_ADVANCED,
              component: () => import('@/components/tabs/HotelTab.vue')
            },
            {
              path: '/external/search/air',
              name: routerKey.AIR_ADVANCED,
              component: () => import('@/components/tabs/AirTab.vue')
            },
            {
              path: '/external/search/cruise',
              name: routerKey.CRUISE_ADVANCED,
              component: () => import('@/components/tabs/CruiseTab.vue')
            }
          ]
        },
        {
          path: '/internal/quotes',
          name: routerKey.QUOTE_MANAGEMENT,
          component: () => import('@/views/internal/Quotes.vue')
        },
        {
          path: '/internal/hotels',
          name: routerKey.HOTELS,
          component: () => import('@/views/internal/Hotels.vue')
        },
        {
          path: '/internal/airs',
          name: routerKey.AIRS,
          component: () => import('@/views/internal/Air/Airs.vue')
        },
        {
          path: '/internal/hotel-contract',
          name: routerKey.HOTEL_CONTRACT,
          component: () => import('@/views/internal/HotelContract.vue')
        },
        {
          path: '/internal/flights',
          name: routerKey.FLIGHTS,
          component: () => import('@/views/internal/Flights.vue')
        },
        {
          path: '/internal/role',
          name: routerKey.ROLES,
          component: () => import('@/views/internal/Roles/Roles.vue')
        },
        {
          path: '/internal/packages',
          name: routerKey.PACKAGES,
          component: () => import('@/views/internal/Package/Packages.vue')
        },
        {
          path: '/internal/tours',
          name: routerKey.TOURS,
          component: () => import('@/views/internal/Tour/Tours.vue')
        },
        {
          path: '/internal/cruises',
          name: routerKey.CRUISE_MANAGEMENT,
          component: () => import('@/views/internal/CruisesManagement/Cruise.vue')
        },
        {
          path: '/internal/promos',
          name: routerKey.PROMOS,
          component: () => import('@/views/internal/Promos.vue')
        },
        {
          path: '/internal/reports',
          name: routerKey.REPORTS,
          component: () => import('@/views/internal/Reports.vue')
        },
        {
          path: '/internal/voucher',
          name: routerKey.VOUCHER,
          component: () => import('@/views/internal/Voucher.vue')
        },
        {
          path: '/internal/currency',
          name: routerKey.CURRENCY,
          component: () => import('@/views/internal/Currency.vue')
        },
        {
          path: '/internal/t&c',
          name: routerKey.TERMS_AND_CONDITIONS,
          component: () => import('@/views/internal/TermsAndConditions.vue')
        },
        {
          path: '/internal/logs',
          name: routerKey.LOGS,
          component: () => import('@/views/internal/Logs.vue')
        },
        {
          path: '/internal/rules-history',
          name: routerKey.RULES_HISTORY,
          component: () => import('@/views/internal/RulesHistory.vue')
        },
        {
          path: '/internal/quote-configurations',
          name: routerKey.QUOTE_CONFIGURATION,
          component: () => import('@/views/internal/QuoteConfiguration.vue')
        },
        {
          path: '/internal/admin_setup',
          name: routerKey.ADMIN_SETUP,
          component: () => import('@/views/internal/AdminSetup.vue')
        },
        {
          path: '/internal/sync-data',
          name: routerKey.SYNC_DATA,
          component: () => import('@/views/internal/SyncData.vue')
        },
        {
          path: '/internal/group-type',
          name: routerKey.GROUP_TYPE,
          component: () => import('@/views/internal/GroupTypes.vue')
        }
      ]
    },
    {
      path: '/pages/empty',
      name: routerKey.EMPTY,
      component: () => import('@/views/pages/Empty.vue')
    },
    {
      path: '/landing-page',
      name: routerKey.LANDING_PAGE,
      component: () => import('@/views/pages/homeBtc/HomePageBtc.vue')
    },
    {
      path: '/maintenance-page',
      name: routerKey.MAINTENANCE_PAGE,
      component: () => import('@/views/pages/Maintenance.vue')
    },
    {
      path: '/error-page',
      name: routerKey.ERROR_PAGE,
      component: () => import('@/views/pages/ErrorPage.vue')
    }
  ]
});

export default router;
